import locale from 'element-ui/lib/locale'
import enLang from 'element-ui/lib/locale/lang/en'
import _, { LoDashStatic } from 'lodash'
import PortalVue from 'portal-vue'
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import VueHead from 'vue-head'

import axios from '@/axios-module'

import App from './App.vue'
import router from './router'
import store from './store'

import './registerServiceWorker'
import './globalFilters'
import './globalMixin'

Vue.config.productionTip = !process.env.VUE_APP_DEBUG_MODE
Vue.prototype.$http = axios

// Allows to use this.$_ in components
Vue.prototype.$_ = _
declare module 'vue/types/vue' {
  interface Vue {
    $_: LoDashStatic
  }
}

Vue.use(VeeValidate, {
  errorBagName: 'veeErrors',
  delay: 500,
  fieldsBagName: 'veeFields',
})

Vue.use(VueHead)
Vue.use(PortalVue)

new Vue({
  router,
  store,
  render: (h: any) => h(App),
}).$mount('#app')

locale.use(enLang)
